import Bugsnag from '@bugsnag/js';
const error = (e, error, errorMsg) => {
  e.dispatch('app/loading', false);
  e.dispatch('notification/text', { type: 'error', msg: errorMsg });
  Bugsnag.notify(error);
};

export default error;